<docs>
  # Responsive
  > responsive magic with custom easing based on a svg curve
  
  @author Nicolas Husson <nicolas@kffein.com>
</docs>

<script lang="ts" setup>
  import { getEnv } from 'config';
import { storeToRefs } from 'pinia';
import { defineAsyncComponent } from 'vue';
import ResponsiveStore from './store';
  
  const SHOW_DEBUG = getEnv('VITE_DEBUG_RESPONSIVE')
  const DebugResponsive = defineAsyncComponent(() => import(/* webpackChunkName: "desbug-responsive" */'./Debug.vue'))

  // display debug tools
  // const DEBUG = true

  const {
    path,
    desktop,
    mobile,
    between,
    ratio,
    ratioEased,
    // updateResponsiveEase
  } = storeToRefs(ResponsiveStore)
</script>
    
<template>
  <component :is="'style'">
    :root {
    --ratio-desktop: {{ desktop }};
    --ratio-mobile: {{ mobile }};
    --ratio-between: {{ between }};
    }
  </component>
  <DebugResponsive v-if="SHOW_DEBUG"
                   :path="path"
                   :ratio="ratio"
                   :ratio-eased="ratioEased"
                   @update="ResponsiveStore.updateResponsiveEase"
  />  
</template>
